<template>
    <div class="content">
        <div class="container">
            <div class="box">
                <div class="con">

                    <h2 class="char" align="center">美</h2>
                    <h3 class="type" align="center">24H项目数量</h3>
                    <p class="number" align="center">
                        <animate-number v-if="isShow" duration="2000" from="0" :to=realtime_num from-color="#82dffe"
                                        to-color="#ffffff"></animate-number>
                    </p>
                    <p class="start" align="center" @click="changePage('/v2/credit-project/realtime')">详情分析</p>
                </div>
            </div>
            <div class="box">
                <div class="con">
                    <h2 class="char" align="center">丽</h2>
                    <h3 class="type" align="center">总项目数量</h3>
                    <p class="number" align="center">
                        <animate-number v-if="isShow" duration="3000" from="0" :to=project_num from-color="#001c43"
                                        to-color="#ffffff"></animate-number>
                    </p>
                    <p class="start" align="center" @click="changePage('/v2/credit-project/project-analysis')">详情分析</p>
                </div>
            </div>
            <div class="box">
                <div class="con">
                    <h2 class="char" align="center"><img @click="changeShow()" style="opacity: 1; height: 80px"
                                                         src="../../../../assets/img/心.png"></h2>
                    <h3 class="type" align="center">编制单位数量</h3>
                    <p class="number" align="center">
                        <animate-number v-if="isShow" duration="4000" from="0" v-bind:to=unit_num from-color="#fe9244"
                                        to-color="#ffffff"></animate-number>
                    </p>
                    <p class="start" align="center" @click="changePage('/v2/credit-project/compile-unit-analysis')">
                        详情分析</p>
                </div>
            </div>
            <div class="box">
                <div class="con">
                    <h2 class="char" align="center">中</h2>
                    <h3 class="type" align="center">编制主持人数量</h3>
                    <p class="number" align="center">
                        <animate-number v-if="isShow" duration="5000" from="0" v-bind:to=host_num from-color="#f422a0"
                                        to-color="#ffffff"></animate-number>
                    </p>
                    <p class="start" align="center" @click="changePage('/v2/credit-project/compile-host-analysis')">
                        详情分析</p>
                </div>
            </div>
            <div class="box">
                <div class="con">
                    <h2 class="char" align="center">国</h2>
                    <h3 class="type" align="center">失信单位人员量</h3>
                    <p class="number" align="center">
                        <animate-number v-if="isShow" duration="6000" from="1" v-bind:to=discredit_num
                                        from-color="#04f2a7" to-color="#ffffff"></animate-number>
                    </p>
                    <p class="start" align="center" @click="changePage('/v2/credit-project/public-supervision')">
                        详情分析</p>
                </div>
            </div>
        </div>

        <!--        <div class="good_box">-->
        <!--            <span>累计点赞量：</span>-->
        <!--            <animate-number duration="6000" from="1" v-bind:to="2000"-->
        <!--                            from-color="#04f2a7" to-color="#ffffff"></animate-number>-->
        <!--        </div>-->
        <div class="visit">
            <el-tooltip
                    class="item"
                    effect="dark"
                    placement="top">
                <span slot="content" style="font-size: 20px; line-height:25px">向右拖动点赞<br/></span>


                <div class="video_box" @mousemove="onMoveBoxBefore">

                    <span>累计点赞量：</span>
                    <animate-number v-if="isDianzanShow" duration="1000" from="1" v-bind:to=dianzhan_num
                                    from-color="#04f2a7" to-color="#ffffff"></animate-number>
                </div>
            </el-tooltip>
            <!--                <div class="video_box" @mousemove="onMoveBoxBefore"></div>-->
        </div>

        <div class="video" v-if="isVideoShow" v-show="isS">
            <video id='slider' width="100%" height="100%" autoplay="autoplay">
                <!--                <source src="http://www.mee.gov.cn/ywgz/xcjy/xccpzyk/mv/202005/P020200508632966010969.mp4" type="video/mp4">-->
                <source id="source"
                        src="http://www.mee.gov.cn/ywgz/xcjy/xccpzyk/mv/202005/P020200508632966010969.mp4"
                        type="video/mp4">
                <!--                <source src="movie.ogg" type="video/ogg">-->
            </video>

        </div>
        <div>
            <!--            <h1>asf</h1>-->
            <div id="realtime-porject-area"></div>
            <ul class="navigation" v-if="isVideoShow">
                <li @click="videoUrl('http://www.mee.gov.cn/ywgz/xcjy/xccpzyk/mv/202005/P020200508632966010969.mp4')">
                    <img src="../../../../assets/img/让中国更美丽.png"></li>
                <li @click="videoUrl('https://vd3.bdstatic.com/mda-kevs8aw2hiv577qa/mda-kevs8aw2hiv577qa.mp4?playlist=%5B%22hd%22%2C%22sc%22%5D')">
                    <img src="../../../../assets/img/环保DISCO.png"></li>
                <li @click="videoUrl('http://mpvideo.qpic.cn/0bf2ciaaiaaanqacqih3hjpfaewdaqjaabaa.f10002.mp4?dis_k=dc3414eddc91da5b3c7622b0a5c44f74&dis_t=1594093514')">
                    <img src="../../../../assets/img/环保人之歌.png"></li>
                <!--                <li @click="videoUrl('http://47.115.168.13/media/%E7%A9%BF%E8%B6%8A%E6%97%B6%E7%A9%BA%E7%9A%84%E6%80%9D%E5%BF%B5.bd14f76a.mp4')">-->
                <!--                    <img src="../../../../assets/img/piano.png"></li>-->

            </ul>
        </div>
        <!--        <div id="realtime-bar">-->
        <!--            &lt;!&ndash;            <ul>&ndash;&gt;-->
        <!--            &lt;!&ndash;                <li v-for="dat in datas" :key="dat.id">{{dat}}</li>&ndash;&gt;-->
        <!--            &lt;!&ndash;            </ul>&ndash;&gt;-->
        <!--        </div>-->
    </div>
</template>

<script>
    import {getIndexNumber} from "../../../../network";
    import {getIndexDdianZanNumber} from "../../../../network";

    export default {
        name: "index",
        data() {
            return {
                drawTargetEle: {},
                isShow: false,
                isDianzanShow: false,
                isVideoShow: false,
                discredit_num: 0,
                realtime_num: 10,
                unit_num: 0,
                host_num: 0,
                project_num: 0,
                series: {},
                option: {
                    // backgroundColor: '#1a4377',

                    // tooltip: {},
                    animationDurationUpdate: 1500,
                    animationEasingUpdate: 'quinticInOut',
                    color: ['#83e0ff', '#45f5ce', '#b158ff'],
                    series: [
                        {
                            type: 'graph',
                            layout: 'force',
                            force: {
                                repulsion: 1500,
                                edgeLength: 100
                            },
                            roam: false,
                            label: {
                                normal: {
                                    show: true
                                }
                            },
                            data: [
                                {
                                    name: '信用环评数据',
                                    label: {
                                        fontSize: 22,
                                    },
                                    symbolSize: 200,
                                    draggable: true,
                                    category: 0,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#04f2a7',
                                            borderWidth: 6,
                                            shadowBlur: 20,
                                            shadowColor: '#04f2a7',
                                            color: '#001c43',
                                        }
                                    }
                                },
                                {
                                    name: '实时数据分析',
                                    symbolSize: 150,
                                    draggable: true,
                                    label: {
                                        fontSize: 18,
                                    },
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#f422a0',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#f422a0',
                                            color: '#001c43',
                                        }
                                    },
                                    category: 1,

                                },
                                {
                                    name: '24H各省项目',
                                    label: {
                                        fontSize: 16,
                                    },
                                    symbolSize: 100,
                                    draggable: true,
                                    category: 1,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#f1bba6',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#f1bba6',
                                            color: '#001c43',
                                        }
                                    },

                                },
                                {
                                    name: '24H行业分布',
                                    symbolSize: 100,
                                    label: {
                                        fontSize: 16,
                                    },
                                    draggable: true,
                                    category: 1,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#f1bba6',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#f1bba6',
                                            color: '#001c43',
                                        }
                                    },

                                },
                                {
                                    name: '24H变化趋势',
                                    symbolSize: 100,
                                    label: {
                                        fontSize: 16,
                                    },
                                    draggable: true,
                                    category: 1,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#f1bba6',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#f1bba6',
                                            color: '#001c43',
                                        }
                                    },

                                },
                                {
                                    name: '项目统计分析',
                                    symbolSize: 150,
                                    label: {
                                        fontSize: 18,
                                    },
                                    draggable: true,
                                    category: 2,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#f422a0',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#f422a0',
                                            color: '#001c43',
                                        }
                                    },

                                },
                                {
                                    name: '项目地区统计',
                                    symbolSize: 100,
                                    label: {
                                        fontSize: 16,
                                    },
                                    draggable: true,
                                    category: 2,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#4766de',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#4766de',
                                            color: '#001c43'
                                        }
                                    },

                                },
                                {
                                    name: '项目行业分布',
                                    draggable: true,
                                    label: {
                                        fontSize: 16,
                                    },
                                    symbolSize: 100,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#4766de',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#4766de',
                                            color: '#001c43'

                                        }
                                    },
                                    category: 2,

                                },
                                {
                                    name: '项目变化趋势',
                                    symbolSize: 100,
                                    label: {
                                        fontSize: 16,
                                    },
                                    draggable: true,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#4766de',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#4766de',
                                            color: '#001c43'
                                        }
                                    },
                                    category: 2,

                                },
                                {
                                    name: '编制单位分析',
                                    symbolSize: 150,
                                    label: {
                                        fontSize: 18,
                                    },
                                    draggable: true,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#f422a0',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#f422a0',
                                            color: '#001c43'
                                        }
                                    },
                                    category: 1,

                                },
                                {
                                    name: '单位地区统计',
                                    symbolSize: 100,
                                    label: {
                                        fontSize: 16,
                                    },
                                    draggable: true,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#fe9244',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#fe9244',
                                            color: '#001c43'
                                        }
                                    },
                                    category: 3,

                                },
                                {
                                    name: '单位业绩排行',
                                    symbolSize: 100,
                                    label: {
                                        fontSize: 16,
                                    },
                                    draggable: true,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#fe9244',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#fe9244',
                                            color: '#001c43'
                                        }
                                    },
                                    category: 3,

                                },
                                {
                                    name: '单位平均业绩',
                                    symbolSize: 100,
                                    label: {
                                        fontSize: 16,
                                    },
                                    draggable: true,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#fe9244',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#fe9244',
                                            color: '#001c43'
                                        }
                                    },
                                    category: 3,

                                },
                                {
                                    name: '编制主持人分析',
                                    symbolSize: 150,
                                    label: {
                                        fontSize: 18,
                                    },
                                    draggable: true,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#f422a0',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#f422a0',
                                            color: '#001c43'
                                        }
                                    },
                                    category: 1,

                                },
                                {
                                    name: '主持人地区统计',
                                    symbolSize: 100,
                                    label: {
                                        fontSize: 16,
                                    },
                                    draggable: true,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#26fe6a',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#26fe6a',
                                            color: '#001c43'
                                        }
                                    },
                                    category: 4,

                                },
                                {
                                    name: '主持人业绩排行',
                                    symbolSize: 100,
                                    label: {
                                        fontSize: 16,
                                    },
                                    draggable: true,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#26fe6a',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#26fe6a',
                                            color: '#001c43'
                                        }
                                    },
                                    category: 4,

                                },
                                {
                                    name: '主持人平均业绩',
                                    symbolSize: 100,
                                    label: {
                                        fontSize: 16,
                                    },
                                    draggable: true,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#26fe6a',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#26fe6a',
                                            color: '#001c43'
                                        }
                                    },
                                    category: 4,

                                },
                                {
                                    name: '公众监督',
                                    symbolSize: 150,
                                    label: {
                                        fontSize: 18,
                                    },
                                    draggable: true,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#f422a0',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#f422a0',
                                            color: '#001c43'
                                        }
                                    },
                                    category: 1,

                                },
                                {
                                    name: '高产人员',
                                    symbolSize: 100,
                                    label: {
                                        fontSize: 16,
                                    },
                                    draggable: true,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#fe4b70',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#fe4b70',
                                            color: '#001c43'
                                        }
                                    },
                                    category: 5,

                                },
                                {
                                    name: '异地经营',
                                    symbolSize: 100,
                                    label: {
                                        fontSize: 16,
                                    },
                                    draggable: true,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#fe4b70',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#fe4b70',
                                            color: '#001c43'
                                        }
                                    },
                                    category: 5,

                                },
                                {
                                    name: '失信对象',
                                    symbolSize: 100,
                                    label: {
                                        fontSize: 16,
                                    },
                                    draggable: true,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#fe4b70',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#fe4b70',
                                            color: '#001c43'
                                        }
                                    },
                                    category: 5,

                                },
                                {
                                    name: '数据查询',
                                    symbolSize: 150,
                                    label: {
                                        fontSize: 18,
                                    },
                                    draggable: true,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#f422a0',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#f422a0',
                                            color: '#001c43'
                                        }
                                    },
                                    category: 1,

                                },
                                {
                                    name: '环评项目',
                                    symbolSize: 100,
                                    label: {
                                        fontSize: 16,
                                    },
                                    draggable: true,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#82dffe',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#04f2a7',
                                            color: '#001c43'
                                        }
                                    },
                                    category: 6,

                                },
                                {
                                    name: '编制单位',
                                    symbolSize: 100,
                                    label: {
                                        fontSize: 16,
                                    },
                                    draggable: true,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#82dffe',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#04f2a7',
                                            color: '#001c43'
                                        }
                                    },
                                    category: 6,

                                },
                                {
                                    name: '编制人员',
                                    symbolSize: 100,
                                    label: {
                                        fontSize: 16,
                                    },
                                    draggable: true,
                                    itemStyle: {
                                        normal: {
                                            borderColor: '#82dffe',
                                            borderWidth: 4,
                                            shadowBlur: 10,
                                            shadowColor: '#04f2a7',
                                            color: '#001c43'
                                        }
                                    },
                                    category: 6,

                                },
                            ],
                            links: [
                                {
                                    source: '信用环评数据',
                                    target: '实时数据分析'

                                },
                                {
                                    source: '实时数据分析',
                                    target: '24H各省项目',
                                },
                                {
                                    source: '实时数据分析',
                                    target: '24H行业分布',
                                },
                                {
                                    source: '实时数据分析',
                                    target: '24H变化趋势',
                                },
                                // --------------------
                                {
                                    source: '信用环评数据',
                                    target: '项目统计分析',
                                },

                                {
                                    source: '项目统计分析',
                                    target: '项目地区统计',
                                },
                                {
                                    source: '项目统计分析',
                                    target: '项目行业分布',
                                },
                                {
                                    source: '项目统计分析',
                                    target: '项目变化趋势',
                                },
                                // --------------------
                                {
                                    source: '信用环评数据',
                                    target: '编制单位分析',
                                },
                                {
                                    source: '编制单位分析',
                                    target: '单位地区统计',
                                },
                                {
                                    source: '编制单位分析',
                                    target: '单位业绩排行',
                                },
                                {
                                    source: '编制单位分析',
                                    target: '单位平均业绩',
                                },
                                // --------------------
                                {
                                    source: '信用环评数据',
                                    target: '编制主持人分析',
                                },
                                {
                                    source: '编制主持人分析',
                                    target: '主持人地区统计',
                                },
                                {
                                    source: '编制主持人分析',
                                    target: '主持人业绩排行',
                                },
                                {
                                    source: '编制主持人分析',
                                    target: '主持人平均业绩',
                                },
                                // --------------------
                                {
                                    source: '信用环评数据',
                                    target: '公众监督',
                                },
                                {
                                    source: '公众监督',
                                    target: '高产人员',
                                },
                                {
                                    source: '公众监督',
                                    target: '异地经营',
                                },
                                {
                                    source: '公众监督',
                                    target: '失信对象',
                                },
                                // --------------------
                                {
                                    source: '信用环评数据',
                                    target: '数据查询',
                                },
                                {
                                    source: '数据查询',
                                    target: '环评项目',
                                },
                                {
                                    source: '数据查询',
                                    target: '编制单位',
                                },
                                {
                                    source: '数据查询',
                                    target: '编制人员',
                                },


                            ],
                            lineStyle: {
                                normal: {
                                    opacity: 0.9,
                                    width: 5,
                                    curveness: 0
                                }
                            },
                            categories: [
                                {name: '0'},
                                {name: '1'},
                                {name: '2'},
                                {name: '3'},
                                {name: '4'},
                                {name: '5'}
                            ]
                        }
                    ]
                },
                ele: '',
                isS: false,
                fullWidth: 0,
                dianzhan_num: 0,
                dianzan: 0,

            }
        }
        ,
        methods: {
            getDidanZan(number) {
                getIndexDdianZanNumber(number).then(response => {


                    this.dianzhan_num = response.data['result'];
                    console.log(response.data)
                    this.isDianzanShow = true;

                }).catch(function (error) {
                    console.log(error)
                });
            },
            onMoveBoxBefore(e) {
                let box = e.target;
                // console.log("bbb:", box.style.left, box.style.top)
                let _xl = e.offsetX, _xr = box.clientWidth - e.offsetX;   //x轴
                let _yt = e.offsetY, _yb = box.clientHeight - e.offsetY;  //y轴
                let aa = 0;
                // console.log(_xl, _yt)
                //鼠标在div边缘0到3之内才可移动
                if (((_xl > 0 && _xl < 310) || (_xr > 0 && _xr < 310)) || ((_yt > 0 && _yt < 60) || (_yb > 0 && _yb < 60))) {
                    box.style.cursor = "all-scroll";
                    box.classList.add("notselect");
                    box.onmousedown = (e) => {
                        //算出鼠标相对元素的位置
                        let disX = e.clientX - box.offsetLeft;
                        let disY = e.clientY - box.offsetTop;
                        document.onmousemove = (e) => {
                            let left = e.clientX - disX;
                            let top = e.clientY - disY;
                            if (left < this.fullWidth + 1) {
                                left = this.fullWidth + 1;
                            }

                            if (left > 1200 + this.fullWidth - 344) {
                                left = 1200 + this.fullWidth - 344;
                                if (aa === 0) {
                                    if (this.dianzan == 5) {
                                        ELEMENT.Message({
                                            message: '点赞小能手！',
                                            type: 'success',
                                            duration: 5000,
                                            showClose: false,
                                            offset: 90,
                                            center: true

                                        });
                                    } else if (this.dianzan == 10) {
                                        ELEMENT.Message({
                                            message: '无敌点赞手！',
                                            type: 'success',
                                            duration: 10000,
                                            showClose: false,
                                            offset: 90,
                                            center: true

                                        });
                                    } else if (this.dianzan == 20) {
                                        ELEMENT.Message({
                                            message: '点赞超人！',
                                            type: 'success',
                                            duration: 20000,
                                            showClose: false,
                                            offset: 90,
                                            center: true

                                        });
                                    }
                                    var text = ['爱国', '敬业', '诚信', '友善', '富强', '民主', '文明', '和谐', '自由', '平等', '公正', '法制', '爱国者 +1 成功']
                                    ELEMENT.Message({
                                        message: text[this.dianzan % 13],
                                        type: 'success',
                                        duration: 1000,
                                        showClose: false,
                                        offset: 90,
                                        center: true

                                    });

                                    this.dianzan += 1;
                                    this.isDianzanShow = false;

                                    this.getDidanZan("0")
                                }
                                aa = 1
                            }
                            var l = "linear-gradient(" + (left - this.fullWidth) / 3 + "deg,#43de65, #534999)";
                            box.style.background = l;
                            box.style.left = left + 'px';
                            box.style.top = '412px';
                        };
                        document.onmouseup = (e) => {
                            document.onmousemove = null;
                            document.onmouseup = null;
                            box.style.left = this.fullWidth + 'px';
                            aa = 0
                        };
                    }
                } else {
                    box.style.cursor = "default";
                    box.classList.remove("notselect");
                    box.onmousedown = null;
                }
            },

            videoUrl(url) {

                this.ele.src = url
                // console.log(url);
                // this.isVideoShow = false;
                // this.medio_url = 'http://www.mee.gov.cn/ywgz/xcjy/xccpzyk/mv/202005/P020200508632966010969.mp4';

                // this.isVideoShow = true;

            },
            changePage(url) {
                // console.log(url);
                this.$router.push(url);
            },
            fetch() {
                return JSON.parse(window.localStorage.getItem("first") || '0');
            },
            save(items) {
                window.localStorage.setItem("first", JSON.stringify(items))
            },
            changeShow() {
                // this.isVideoShow = !this.isVideoShow;
                // this.ele = document.getElementById("slider");
                // console.log(this.ele)
                this.isVideoShow = !this.isVideoShow;

                this.$nextTick(function () {
                    this.ele = document.getElementById("slider");
                });
                this.isS = true;
            }
        }
        ,
        created() {
            this.fullWidth = (document.documentElement.clientWidth - 1200) / 2;
            // console.log("width", this.fullWidth)
        }
        ,
        mounted() {
            this.getDidanZan("1");

            getIndexNumber().then(response => {

                this.discredit_num = response.data['result']['discredit_num'];
                this.realtime_num = response.data['result']['realtime_num'];
                this.unit_num = response.data['result']['unit_num'];
                this.host_num = response.data['result']['host_num'];
                this.project_num = response.data['result']['project_num'];
                this.isShow = true;

            }).catch(function (error) {
                console.log(error)
            });


            var echarts = require('echarts');
            var myChart = echarts.init(document.getElementById('realtime-porject-area'));

            myChart.setOption(this.option, true);
            var first = this.fetch();
            // console.log(first)
            if (first === 0) {
                ELEMENT.Message({
                    message: '推荐使用谷歌浏览器，分辨率1920*1080最佳。' +
                        '如显示不正常，可调整浏览器缩放比例或点击右上角全屏！',
                    type: 'success',
                    duration: 0,
                    showClose: true,
                    offset: 70,
                });
                this.save("1")
            }

        }

    }
</script>

<style scoped>


    .notselect {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }


    .visit {
        /*display: flex;*/
        /*justify-content: center;*/
        /*align-items: center;*/
        font-size: 30px;
        color: #f8f8f8;
        margin-top: 30px;
        transition: 0.5s;
        border: 2px solid;
        border-radius: 25px;
        height: 64px;

    }

    .video_box {
        border: 2px solid;
        border-radius: 25px;
        background: linear-gradient(315deg, #43de65, #534999);
        padding: 10px 20px 10px 20px;
        cursor: move;
        position: absolute;
        z-index: 333;
        width: 300px;
    }

    .good_box {
        border: 2px solid;
        border-radius: 25px;
        background: linear-gradient(315deg, #43de65, #534999);
        padding: 10px 20px 10px 20px;
        cursor: move;
        position: absolute;
        z-index: 333;
        width: 300px;
    }

    /*.video_box:hover {*/
    /*    background: linear-gradient(315deg, #DE4799, #8a991c);*/
    /*    !*cursor: pointer;*!*/
    /*}*/


    .content {

        height: 200vh;
        width: 1200px;
        /*background-color: #71a4d1;*/
        /*display: block;*/
    }


    .container {
        width: 1200px;
        height: 200px;
        margin-top: 180px;
        position: relative;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
        grid-template-rows: auto;
        grid-gap: 0 37px;
        /*background-color: #71a4d1;*/
        z-index: 10;
    }

    .container .box:before {
        content: '';
        position: absolute;
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;

    }

    .container .box:nth-child(1):before {
        background: linear-gradient(315deg, #de6c90, #995a83);
    }

    .container .box:nth-child(2):before {
        background: linear-gradient(315deg, #e4a455, #995a83);
    }

    .container .box:nth-child(3):before {
        background: linear-gradient(315deg, #5adebc, #995a83);
    }

    .container .box:nth-child(4):before {
        background: linear-gradient(315deg, #b7de69, #995a83);
    }

    .container .box:nth-child(5):before {
        background: linear-gradient(315deg, #4766de, #995a83);
    }


    .container .box {

        position: relative;
        height: 200px;
        width: 200px;
        /*background-color: #060c21;*/
        display: flex;
        justify-content: center;
        align-items: center;
        /*border: 1px solid #000;*/
        /*z-index: -1;*/
    }

    .con {

        position: relative;
        /*padding: 20px;*/
        width: 200px;
        /*z-index: 10;*/
        align-items: center;
    }

    .box .con .char {
        position: relative;
        top: 14px;
        /*right: 20px;*/
        /*padding-left: 60px;*/
        /*margin: 0;*/
        /*margin-left: auto;*/
        /*margin-right: ;*/
        align-items: center;
        /*padding: 0;*/
        font-size: 6em;
        color: #fff;
        transition: 0.5s;
        opacity: 0;
    }

    .box:hover .con .char {
        /*top: 15px;*/
        opacity: 1;
    }

    .box .con p {
        margin-top: -80px;
        user-select: none;
    }

    .box .con .number {
        position: relative;
        top: -180px;
        /*right: 20px;*/
        /*padding-left: 60px;*/
        /*margin: 0;*/
        /*margin-left: auto;*/
        align-items: center;
        /*padding: 0;*/
        font-size: 38px;
        font-weight: bold;
        color: rgba(255, 255, 255, 0.5);
        transition: 0.5s;
        opacity: 1;
        margin: 0;
        padding: 0;
        color: #fff;
        /*font-size: 16px;*/
    }

    .box:hover .con .number {
        top: -50px;
        opacity: 0;
    }

    .box .con .type {
        /*margin: 0 0 50px;*/
        margin-bottom: 70px;
        /*padding: 0;*/
        font-size: 20px;
        font-weight: 500;
        color: #fff;
        /*margin-top: 200px;*/
    }


    .box .con .start {
        position: relative;
        /*margin: 20px 0 0;*/
        /*margin-left: 20px;*/
        /*width: 100px;*/
        padding: 10px 10px;
        text-decoration: none;
        border: 1px solid #fff;
        /*display: inline-block;*/
        color: #fff;
        transition: 0.5s;
        transform: translateY(-80px);
        opacity: 0;
        visibility: hidden;

    }

    .box:hover .con .start {
        transform: translateY(-30px);
        opacity: 1;
        visibility: visible;
    }

    .box .con .start:hover {
        color: #1b2947;
        background: #fff;
        cursor: pointer;
    }

    #realtime-porject-area {
        margin-top: 0px;
        width: 100%;
        height: 150vh;
        float: left;
        z-index: 0;
        /*margin-left: 400px;*/
        /*margin-top: 30px;*/
        /*padding-top: 60px;*/
        /*background-color: #f7f7f7;*/
    }

    .video {
        height: 200vh;
        /*background-color: #75bd35;*/
        position: absolute;
        z-index: 0;
        top: 0;
        left: 0;
        right: 0;
        opacity: 0.2;
        /*min-height: 100%;*/
        /*min-width: 100%;*/
        border-radius: 50px 50px 50px 50px;
        /*margin: 60px 60px 0 60px;*/
    }

    .video video {
        position: absolute;
        /*z-index: -1;*/
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .navigation {
        position: absolute;
        top: 500px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .navigation li {
        list-style: none;
        cursor: pointer;
        margin: 0 10px;
        border-radius: 4px;
        background: #fff;
        padding: 3px 3px 0;
        opacity: 0.7;
    }

    .navigation li:hover {
        opacity: 1;
    }

    .navigation li img {
        width: 120px;
        transition: 0.5s;
        /*height: 70px;*/
    }

    .navigation li img:hover {
        width: 200px;
    }
</style>